// extracted by mini-css-extract-plugin
export default {"zoomModal":"j2-z"};